import React from "react";
import { useNavigate } from "react-router-dom";

const LetsTalk = () => {
  const navigate = useNavigate()
  
  return (
    <section className="wine-letstalk-section px-6 py-10">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        {/* Left Side */}
        <div className="space-y-6">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[--neutral-white] leading-snug">
            Let’s Talk Wine 🍷
          </h2>
          <p className="text-[--neutral-white] text-base leading-relaxed">
            Whether you're a passionate wine enthusiast, a restaurant owner, or just curious about our process — we're here to chat.
            From fermentation to flavor, we believe every bottle has a story worth sharing.
          </p>

          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <span className="text-[--accent-gold] text-xl">🍇</span>
              <p className="text-[--neutral-white] text-sm">
                <strong>Heritage Rich:</strong> Each batch is brewed with traditional techniques passed down generations.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-[--accent-gold] text-xl">🍇</span>
              <p className="text-[--neutral-white] text-sm">
                <strong>Natural Ingredients:</strong> No synthetic flavorings — only pure fruit extracts, wheat, and herbal notes.
              </p>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-[--accent-gold] text-xl">🍇</span>
              <p className="text-[--neutral-white] text-sm">
                <strong>Made with Passion:</strong> Every bottle is handcrafted with patience, precision, and love.
              </p>
            </div>
          </div>

          <button className="bg-[--accent-gold] text-[--neutral-black] font-semibold px-6 py-3 hover:bg-[--accent-gold-hover] transition mt-4" onClick={() => navigate("/products")}>
            Explore Our Wines
          </button>
        </div>

        {/* Right Side Form */}
        <form className="bg-white shadow-md p-8 space-y-6 mt-3">
          <div>
            <label className="block text-sm font-medium text-gray-700">Name</label>
            <input
              type="text"
              placeholder="Your full name"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[--primary-wine] focus:border-[--primary-wine] outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              placeholder="you@example.com"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[--primary-wine] focus:border-[--primary-wine] outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Phone</label>
            <input
              type="tel"
              placeholder="+91 98765 43210"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[--primary-wine] focus:border-[--primary-wine] outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Message</label>
            <textarea
              rows="4"
              placeholder="Tell us how we can help..."
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md resize-none focus:ring-[--primary-wine] focus:border-[--primary-wine] outline-none"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-[--primary-wine] text-white font-semibold py-3 rounded-md hover:bg-[--primary-wine-hover] transition"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default LetsTalk;
